module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c430d35ee228bc8ecba3e8b87b311b5e.png";